export type SettingsTabKey =
  | 'users'
  | 'content'
  | 'company-info'
  | 'contractor-types'
  | 'cluster-regions'
  | 'stations'
  | 'notifications'
  | 'document-analysis'
  | 'question-categories';

export type SettingsTab = { key: SettingsTabKey; label: string };

// `company-info` is reused as the URL key for the Vendor Information (labels)
// tab so a bookmarked `?tab=company-info` still resolves after the split.
export const SETTINGS_TABS: readonly SettingsTab[] = [
  { key: 'users', label: 'Users' },
  { key: 'content', label: 'Portal Content' },
  { key: 'company-info', label: 'Vendor Information' },
  { key: 'contractor-types', label: 'Contractor Types' },
  { key: 'cluster-regions', label: 'Cluster Regions' },
  { key: 'stations', label: 'Stations' },
  { key: 'notifications', label: 'Notifications' },
  { key: 'document-analysis', label: 'Document Analysis' },
  { key: 'question-categories', label: 'Question Categories' },
] as const;

const TAB_KEYS = new Set<string>(SETTINGS_TABS.map((t) => t.key));

// Resolve a raw `?tab=` value to a valid key, falling back to 'users'.
export function resolveSettingsTab(tabParam: string | null | undefined): SettingsTabKey {
  return tabParam && TAB_KEYS.has(tabParam) ? (tabParam as SettingsTabKey) : 'users';
}
